<template>
    <div>
        <h2 class="text-center pt-3" v-text="$t('ORDER_VASE_FREDDIES_VASE')"></h2>
        <paper-section>
            <div class="container mx-auto">
                <div class="flex flex-wrap">
                    <div class="lg:w-2/5 md:w-1/2 w-full mx-auto">
                        <img src="@/assets/images/pages/vase/vase.jpg">
                    </div>
                    <div class="lg:w-2/5 md:w-1/2 mx-auto w-full text-center pb-4 px-4">
                        <h3 class="m-0 lg:mt-4 pt-8">{{$root.country.currency.symbol}}{{ $t('ORDER_VASE_VASE_PRICE') }}</h3>
                        <small class="m-0 font-thin"><i v-text="$t('ORDER_VASE_FREE_DELIVERY')"></i></small>
                        <p class="pb-3" v-html="$t('ORDER_VASE_TO_ORDER', { phone, email})"></p>
                        <p class="pb-4" v-text="$t('ORDER_VASE_WE_DESIGNED')"></p>
                        <p v-text="$t('ORDER_VASE_BESPOKE')"></p>
                    </div>
                </div>
            </div>
        </paper-section>
        <div class="container mx-auto mt-12">
            <h2 class="text-center" v-text="$t('ORDER_VASE_DESIGN_FEATURES')"></h2>
            <div class="flex flex-wrap mt-8 mb-16">
                <div class="lg:w-2/5 md:w-1/2 md:ml-auto mx-auto my-auto">
                    <img class="h-40 md:mr-8 md:-mt-5 float-right" :src="imageUrl">
                </div>
                <div class="lg:w-2/5 md:w-1/2 mr-auto">
                    <div class="text-center">
                        <p class="md:text-left lg:p-0 md:pr-4 p-4" v-text="$t('ORDER_VASE_THE_FREDDIES_VASE')"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PaperSection from '@/components/structure/PaperSection';

export default {
    name: 'OrderVase',
    data() {
        return {
            phone: process.env.VUE_APP_TELEPHONE,
            email: process.env.VUE_APP_EMAIL,
        };
    },
    components: {
        PaperSection,
    },
    computed: {
        imageUrl() {
            return require(`@/assets/images/pages/vase/vase_details_${process.env.VUE_APP_I18N_LOCALE}.svg`);
        },
    },
};
</script>
